<template>
  <div class="content1">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
      <div class="box">
        <div class="title">
          基本信息
        </div>
        <el-form-item label="活动名称" class="fixedWidth" prop="title">
          <el-input v-model="form.title" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="节日名称">
          <el-radio-group
            v-model="form.customss"
            @change="customStuatus = form.customss"
          >
            <el-radio :label="0">推荐节日</el-radio>
            <el-radio :label="1">自定义节日 </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="fixedWidth">
          <div class="flex" v-if="customStuatus == '0'">
            <div class="color">已选择： 五一劳动节</div>
            <el-button size="mini" @click="dialogFormVisible = true"
              >重新选择</el-button
            >
          </div>
          <div v-else>
            <el-input
              v-model="form.title"
              size="mini"
              placeholder="请输入节日名称"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="日期选择">
          <div class="flex" v-if="customStuatus == '0'">
            <div class="color">未选择</div>
          </div>
          <div v-else>
            <el-select
              v-model="form.region"
              placeholder="请选择"
              class="newInputWidth"
              size="mini"
            >
              <el-option label="一月" value="shanghai"></el-option>
              <el-option label="二月" value="beijing"></el-option>
            </el-select>
            <el-select
              v-model="form.region"
              placeholder="请选择"
              class="newInputWidth inputMargin"
              size="mini"
            >
              <el-option label="1" value="shanghai"></el-option>
              <el-option label="2" value="beijing"></el-option>
            </el-select>
            <el-radio-group v-model="form.customss">
              <el-radio :label="0">公历</el-radio>
              <el-radio :label="1">农历 </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="节日名称">
          <div class="flex">
            <el-date-picker
              v-model="form.date"
              size="small"
              type="year"
              placeholder="选择年"
            >
            </el-date-picker>
            <div class="color">活动至该年节日日期结束</div>
          </div>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          参与规则
        </div>
        <el-form-item label="参与对象">
          <el-radio-group v-model="form.take_status">
            <el-radio label="0">全部会员</el-radio>
            <!-- <el-radio label="1">按用户标签</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <!--  v-show="form.take_status == '3'" -->
        <!-- <el-form-item label="用户标签选择" v-show="form.take_status == '1'">
          <multipleChoice
            :alone="1"
            :editDatas="checkedVip"
            :Datas="vipData"
            @checkedGoods="checkedGoods(1, $event)"
            ref="vipChild"
          ></multipleChoice>
        </el-form-item> -->
      </div>
      <div class="box">
        <div class="title">
          活动奖品
        </div>

        <el-form-item class="fixedWidth" label="优惠券">
          <div class="fontSize14 marginBottom" style="display: flex">
            <div class="inputMargin ">
              <el-button
                size="small"
                plain
                icon="el-icon-plus"
                @click="selectCoupon"
                >选择券</el-button
              >
              <div style="display:flex;flex-wrap: wrap; margin-top: 10px;">
                <el-tag
                  v-for="(tag, index) in sList"
                  :key="index"
                  closable
                  @close="delTagItem(id)"
                  style="margin-bottom:5px;margin-right:5px;"
                >
                  {{ tag.name }}
                </el-tag>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="积分" class="fixedWidth">
          <div style="display:flex">
            送
            <div class="newInputWidth inputMargin">
              <el-input
                size="small"
                v-model="form.point"
                type="number"
                @blur="form.point = Number(form.point).toFixed(2)"
              ></el-input>
            </div>
            积分
          </div>
        </el-form-item>
        <el-form-item label="余额" class="fixedWidth">
          <div style="display:flex">
            送
            <div class="newInputWidth inputMargin">
              <el-input
                type="number"
                size="small"
                v-model="form.balance"
                @blur="form.balance = Number(form.balance).toFixed(2)"
              ></el-input>
            </div>
            余额
          </div>
        </el-form-item>
        <!-- <el-form-item label-width="80px">
          <el-checkbox-group v-model="checkList">
            <div class="flex marginBottom10">
              <el-checkbox label="0">
                <div class="fontSize14 marginBottom" style="display: flex">
                  <div class="fixedWidth60">
                    优惠券
                  </div>
                  <div class="inputMargin ">
                    <el-button
                      size="small"
                      plain
                      icon="el-icon-plus"
                      @click="selectCoupon"
                      >选择券</el-button
                    >
                    <div
                      style="display:flex;flex-wrap: wrap; margin-top: 10px;"
                    >
                      <el-tag
                        v-for="(tag, index) in sList"
                        :key="index"
                        closable
                        @close="delTagItem(id)"
                        style="margin-bottom:5px;margin-right:5px;"
                      >
                        {{ tag.name }}
                      </el-tag>
                    </div>
                  </div>
                </div>
              </el-checkbox>
            </div>
            <div class="flex marginBottom10">
              <el-checkbox label="">
                <div class="flex">
                  <div class="fixedWidth60">
                    积分
                  </div>
                  送
                  <div class="newInputWidth inputMargin">
                    <el-input size="small" v-model="form.point"></el-input>
                  </div>
                  积分
                </div>
              </el-checkbox>
            </div>
            <div class="flex marginBottom10">
              <el-checkbox label="">
                <div class="flex">
                  <div class="fixedWidth60">
                    余额
                  </div>
                  送
                  <div class="newInputWidth inputMargin">
                    <el-input size="small" v-model="form.balance"></el-input>
                  </div>
                  余额
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item> -->
      </div>
    </el-form>
    <!-- 底部提交 -->
    <div class="bottom">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="submit('ruleForm')">确定</el-button>
    </div>
    <!-- 优惠券弹窗 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></selectCommodity>
    </el-dialog>
    <!-- 节假日弹窗 -->
    <el-dialog title="请选择节日" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-position="top" class="holidayDialog">
        <el-form-item label="推荐节日">
          <el-radio-group v-model="form.resource">
            <el-radio label="春节"></el-radio>
            <el-radio label="五一劳动"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="传统节日">
          <el-radio-group v-model="form.resource">
            <el-radio label="">春节</el-radio>
            <el-radio label="">元宵节</el-radio>
            <el-radio label="">清明节</el-radio>
            <el-radio label="">端午节</el-radio>
            <el-radio label="">七夕</el-radio>
            <el-radio label="">中秋节</el-radio>
            <el-radio label="">重阳节</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="西方节日">
          <el-radio-group v-model="form.resource">
            <el-radio label="">情人节</el-radio>
            <el-radio label="">万圣节</el-radio>
            <el-radio label="">圣诞节</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="公众节日">
          <el-radio-group v-model="form.resource">
            <el-radio label="">妇女节</el-radio>
            <el-radio label="">五一劳动节</el-radio>
            <el-radio label="">儿童节</el-radio>
            <el-radio label="">母亲节</el-radio>
            <el-radio label="">父亲节</el-radio>
            <el-radio label="">国庆节</el-radio>
            <el-radio label="">520</el-radio>
            <el-radio label="">元旦</el-radio>
            <el-radio label="">双十一</el-radio>
            <el-radio label="">双十二</el-radio>
            <el-radio label="">年中大促618</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import multipleChoice from "@/components/commodity/multipleChoice.vue";
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee";
import { vipList } from "@/api/vip";
import time from "@/utils/time";
import { addAttention, editAttention, detailAttention } from "@/api/market";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    selectCommodity,
    multipleChoice,
  },
  data() {
    return {
      customStuatus: 0,
      dialogFormVisible: false,
      initStatus: false,
      jude: this.$route.query.status,
      // 优惠券数据
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      // end
      checkList: [],
      form: {
        customss: "0",
        date: "",
        title: "",
        start_time: "", //活动开始时间
        end_time: "",
        point: "",
        balance: "",
        coupon: "",
        region: "",
      },
      rules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        start_time: [
          { required: true, message: "请输入活动开始时间", trigger: "blur" },
        ],
      },
      // 规则一，活动层级
      // form.give_status: "0",
      // 数字转成汉字
      tranformHanzi: {},
    };
  },
  beforeMount() {
    if (this.$route.query.status != 0) {
      this.initStatus = true;
      console.log("我走这一步", this.$route.query.status);
      this.details();
    }
  },
  methods: {
    // 提交
    submit(formitem) {
      this.$nextTick(() => {
        this.form;
      });
      console.log("提交之前的数据", this.form);
      this.$refs[formitem].validate((valid) => {
        if (valid) {
          let data = { ...this.form };
          data.app_id = this.app_id;
          data.token = this.token;
          if (this.jude == 0) {
            addAttention(data).then((res) => {
              if (res.code == 200) {
                this.$message.success("保存成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
            });
          } else {
            editAttention(data).then((res) => {
              if (res.code == 200) {
                this.$message.success("编辑成功");
                this.$router.go(-1);
              } else {
                this.$message.warning(res.msg);
              }
              console.log("保存", res);
              console.log("编辑", res);
            });
          }
          console.log("data", data);
        } else {
          this.$message.warning("请填写必填项！！");
        }
      });
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      let arrCountId = [];
      data.forEach((item) => {
        arrCountId.push(item.id);
      });
      this.sList = data;

      this.form.coupon = arrCountId.join(",");
      // this.sList = data;
      this.showSelecter = false;
      console.log("点击", this.form.coupon, this.sList);
    },
    //删除选择的优惠券
    delTagItem(x) {
      console.log(x);
      this.sList.splice(x, 1);
      let j = 0;
      let idArr = [];
      for (j in this.sList) {
        idArr.push(this.sList[j].id);
      }
      this.form.coupon = idArr.join(",");
      console.log("删除", this.form.coupon, this.sList);
    },
    selectCoupon() {
      console.log("选择优惠券");
      this.sList = this.sList;
      this.showSelecter = true;
    },
    details() {
      detailAttention({
        token: this.token,
        app_id: this.app_id,
        id: this.jude,
      }).then((res) => {
        console.log("vip", res);
        this.form = res.data;
        delete this.form.create_time;
        delete this.form.update_time;
        this.form.start_time = time.setDate(this.form.start_time);
        this.form.end_time = time.setDate(this.form.end_time);
        this.sList = this.form.coupon_list;
        let i = 0;
        for (i in this.sList) {
          this.sList[i].name = this.sList[i].title;
          this.sList[i].url =
            "https://yckj-common.oss-cn-beijing.aliyuncs.com/1576482532.jpg";
        }
        console.log("wef", this.form.rule);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.holidayDialog {
  .el-radio {
    margin-bottom: 30px;
  }
}
.el-form-item {
  margin-bottom: 15px;
}
.content1 {
  border: 1px solid #f1f1f1;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100%;
  // 上层
  .el-form {
    flex: 1;
    padding: 0 20px 10px 20px;
    overflow-y: auto;
    .box {
      background: #f2f2f6;
      margin-top: 20px;
      padding: 10px;
      border-radius: 6px;
      .title {
        font-weight: 550;
        padding: 10px 0px 10px 20px;
      }
      // 样式
      .fontSize14 {
        font-size: 14px;
      }
      .textAlign {
        text-align: right;
      }
      .color {
        margin: 0px 5px;
        color: #999;
        font-size: 12px;
      }
      .inputMargin {
        width: auto;
        margin: 0 6px;
      }
      .inputWidth {
        height: 30px;
        width: 130px;
      }
      .newInputWidth {
        height: 30px;
        width: 120px;
      }
      .fixedButton {
        width: 70px;
      }
      .width30 {
        width: 30px;
        font-size: 14px;
      }
      .marginBottom10 {
        margin-bottom: 20px;
      }
    }
    // 表格
    .table {
      max-width: 900px;
      border: 1px solid #fff;
      background: #fff;
      height: 100%;
      display: flex;
      border-radius: 6px;
      > div {
        padding: 20px;
      }
      .name {
        font-weight: 550;
        padding: none;
      }
      .table-left {
        width: 220px;
        border-right: 1px solid #f1f1f1;
      }
      .table-right {
        flex: 1;
        .marginBottom {
          margin-bottom: 10px;
        }
        margin-bottom: 10px;
      }
    }
  }
  // 底部
  .bottom {
    border-top: 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .fixedWidth {
    width: 500px;
    .line {
      text-align: center;
    }
  }
  .fixedWidth60 {
    width: 60px;
    padding-right: 6px;
  }
}
</style>
